import React, { FC, useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import RoutedContainer from '@lib/RoutedContainer';
import { AppContext } from '@/layout/Main';
import TeacherSetup from './components/TeacherSetup';
import TeacherSSOLink from './components/TeacherSSOLink';
import TeacherWelcome from './components/TeacherWelcome';
import TeacherWelcomeContainer from './containers/TeacherWelcomeContainer';
import { Context } from '../common/routingTypes';
import createStore from './store/teacherRegistrationStore';

const RegisterNewTeacherRouter: FC = () => {
  const { accessToken } = useContext(AppContext) as Context;
  const store = createStore({}, accessToken);

  return (
    <Routes>
      <Route path="/" element={<RoutedContainer Container={TeacherWelcomeContainer} store={store} jwt={accessToken} />}>
        <Route path="welcome" element={<TeacherWelcome />} />
        <Route path="link" element={<TeacherSSOLink jwt={accessToken} />} />
        <Route path="setup" element={<TeacherSetup jwt={accessToken} />} />
        <Route path="*" element={<Navigate to={'welcome'} replace />} />
      </Route>
    </Routes>
  );
};

export default RegisterNewTeacherRouter;
